import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Calendar } from 'primeng/calendar';
import { DateTimeUtil } from '../../utils/date-time-util';
import { MascaraDataUtil } from '../../utils/mascara-data-util';

@Component({
  selector: 'app-my-calendar',
  templateUrl: './my-calendar.component.html',
  styleUrls: ['./my-calendar.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MyCalendarComponent),
      multi: true }
  ]
})
export class MyCalendarComponent implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {

  @ViewChild('calendar') private calendar: Calendar;

  @Input() public dataSelecionada: Date;

  @Input() public bloqueado = false;

  @Input() public minDate: Date = null;

  @Input() public obrigatorio = false;

  @Input() public placeholder = 'Data';

  @Input() public yearNavigator = false;

  @Input() public yearRange = null;

  @Input() public inputStyle = null;

  private dateTimeUtil: DateTimeUtil = null;

  @Input() public ngModelChange: Function = null;


  constructor() {
    this.dateTimeUtil = new DateTimeUtil();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.setupCalendar();
  }

  ngOnDestroy(): void {
    this.dateTimeUtil = null;
  }

  setupCalendar(): void {
    this.calendar.hideOnDateTimeSelect = true;
  }

  public selecionarData(value: Date): void {
    this.onChange(value);
    this.dataSelecionada = value;
  }

  public esconderPopup(): void {
    this.calendar.hideOverlay();
  }

  public focus(): void {
    if ( this.calendar ) {
      this.calendar.focus = true;
      this.calendar.inputfieldViewChild.nativeElement.focus();
    }
  }

  public onEnter(event: any): void {
    const data = this.dateTimeUtil.stringBrToDate(event?.target?.value);
    if ( data ) {
      this.dataSelecionada = data;
      this.calendar.hideOverlay();
    }
  }

  // validar caracteres digitados
  // private regexCaracteresPermitidos = '/[0-9/-hHp+puUtTfFlL]/';
  // public onKeyDown(event): boolean {
  //   if ( event.key ) {
  //     const which = event.which;
  //     if (which === 8 ||  // delete
  //         which === 46 || // backspace
  //         which === 13) { // enter
  //       return true;
  //     }
  //     return !!event.key.match(this.regexCaracteresPermitidos);
  //   }
  //   return true;
  // }

  public onInput(event: any): void {
    MascaraDataUtil.MascaraData(event, event.target);
    const data = this.dateTimeUtil.stringBrToDate(event?.target?.value);
    this.selecionarData( data );
  }

  /* CONTROL VALUE ACCESSOR - BEGIN */
  private onChange: Function;
  private onTouched: Function;

  writeValue(obj: any): void {
    this.dataSelecionada = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.bloqueado = isDisabled;
  }
  /* CONTROL VALUE ACCESSOR - END */

}
